import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core/styles';
import { ReactComponent as MenuIcon } from '../../../assets/icons/menu.svg';
import { ReactComponent as AppLogo } from '../../../assets/appLogo.svg';
// import { ReactComponent as ARLogo } from '../../../assets/ARMedicid_logo.svg';

import styles from './styles';

const HeaderMenu = ({ toggleDrawer, title, appTitle, classes, isOpen }) => (
  <AppBar position="static" className={classes.headerWithMenu}>
    <IconButton
      color="inherit"
      aria-label="Menu"
      onClick={() => toggleDrawer(true)}
      id="HeaderMenuIcon"
      className={classes.menuIcon}
      disabled={isOpen}
    >
      <MenuIcon className={classes.SvgIcon} />
    </IconButton>

    <Hidden smDown>
      <div className="headerLogosWrapper">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <AppLogo style={{ width: 65, paddingRight: '15px' }} />
          <h2 className={classes.appHeader}>{appTitle}</h2>
        </div>
        {/* <div className="vendorName1">
          <ARLogo className={classes.logoStyle} alt="Arkansas logo" />
        </div> */}
      </div>
    </Hidden>
    <Hidden mdUp>
      <Typography variant="h1" className={classes.homeTxtStyle}>
        {title}
      </Typography>
    </Hidden>
  </AppBar>
);

HeaderMenu.propTypes = {
  toggleDrawer: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  appTitle: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default withStyles(styles)(memo(HeaderMenu));
